module.exports = __webpack_public_path__ + "static/media/ilya-pavlov-87438.f1eb6a65.jpg";